var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from '@ally/metronome-ui';
import { useField } from 'formik';
import moment from 'moment';
import React from 'react';
import { TextInput } from '../inputs';
export const defaultValidate = (value, required) => {
    const isValid = moment(value, 'MM/DD/YYYY', true).isValid();
    // if the input is not required then an empty field should never show a validation error
    if (!required && !value) {
        return undefined;
    }
    if (required && !value) {
        return 'Enter a valid date.';
    }
    if (!isValid) {
        return 'Enter a date in the following format: mm/dd/yyyy.';
    }
    return undefined;
};
const DateInput = React.forwardRef((_a, ref) => {
    var { className, name, onBlur, onChange, label = 'Date', required = false, validate, width, autoComplete = 'off', hidePlaceholder = false, contextualHelpContent } = _a, props = __rest(_a, ["className", "name", "onBlur", "onChange", "label", "required", "validate", "width", "autoComplete", "hidePlaceholder", "contextualHelpContent"]);
    if (ref === void 0) { ref = null; }
    const fallback = (value) => defaultValidate(value, required);
    const formatWithSlashes = (value) => {
        // removes all non-digits
        const newValue = value && value.replace(/[^0-9]/g, '');
        if (newValue.length < 8) {
            return value;
        }
        const month = newValue && newValue.substring(0, 2);
        const day = newValue && newValue.substring(2, 4);
        const year = newValue && newValue.substring(4);
        const formattedDate = `${month}/${day}/${year}`;
        return formattedDate;
    };
    const [field, meta, helpers] = useField(Object.assign(Object.assign({}, props), { name, validate: validate || fallback }));
    const handleOnChange = (e) => {
        field.onChange(e);
        const newValue = e.target.value;
        helpers.setValue(newValue ? formatWithSlashes(newValue) : null);
        if (onChange) {
            onChange(e);
        }
    };
    const handleOnBlur = (e) => {
        field.onBlur(e);
        if (onBlur) {
            onBlur(e);
        }
    };
    const errorMessage = meta.touched ? meta.error : '';
    const placeholder = hidePlaceholder ? undefined : 'mm/dd/yyyy';
    return (React.createElement(Box, { className: className, width: width },
        React.createElement(TextInput, Object.assign({ labelContent: label, required: required, autoComplete: autoComplete, isPrivate: true, inputType: "text", errorNotification: { message: errorMessage }, onChange: handleOnChange, onBlur: handleOnBlur, name: name, value: field.value, placeholder: placeholder, validate: validate || fallback, contextualHelp: {
                content: contextualHelpContent,
                variant: 'stacked',
            }, ref: ref }, props))));
});
export default DateInput;
//# sourceMappingURL=DateInput.js.map